import React, { ReactNode, useState } from 'react';
import { Link, useNavigate } from "react-router-dom";
import Menu from "~/components/Menu";
import HeaderBg from "~/assets/svg/headerBg.svg";
import MenuLines from "~/assets/svg/menuLines.svg";
import Logo from "~/assets/logo.png";
import Levander01 from "~/assets/levander.png";

import "./style.less";

export interface IMainContent{
	children: ReactNode;
}

export default function MainContent({
	children = null,
} : IMainContent) {
	const navigate = useNavigate();
	const hiddenState = location.pathname.indexOf("martinek") !== -1 || location.pathname.indexOf("messenger") !== -1 || location.pathname.indexOf("galerie") !== -1;
	const [showHidden, setShowHidden] = useState(hiddenState);

	function goToHome() {
		navigate('/');
	}

	return <div className="mainContent">
		<img src={Levander01} alt="" className="mainContent__levander01" />
		<img src={Levander01} alt="" className="mainContent__levander02" />
		<div className="mainContent__header" style={{ backgroundImage: `url(${HeaderBg})` }}>
			<Link to="/" className="mainContent__logoPart" onClick={goToHome} onDoubleClick={() => setShowHidden(true)}>
				<img src={Logo} alt="Logo" className="mainContent__logo" />
				<div>
					<span className="mainContent__leftName">Roman</span>
					<span className="mainContent__separator">&</span>
					<span className="mainContent__rightName">Lenka</span>
				</div>
			</Link>
			<p className="mainContent__anon">Se budou brát!</p>
			<Menu showHidden={showHidden} />
			<div className="mainContent__menuLinesCover">
				<img className="mainContent__menuLines" src={MenuLines} alt="" />
			</div>
		</div>
		<div className="mainContent__cont">
			{children}
		</div>
	</div>;
}
